import React from 'react';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Divider from '@material-ui/core/Divider';
import {Styles} from './Styles';
import {Play} from './Inc';
import Ajax from './Ajax';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faArrowDown,faHeart } from '@fortawesome/free-solid-svg-icons';


interface Props {
    uid:string,
    play:Play,
    end():void,
}

const Tweet = (props:Props)=> {
    Ajax.setUid(props.uid);
    const classes = Styles.base();
    const next = ()=>{
        props.end();
    }

    library.add(fab,faArrowDown,faHeart);

    let text = props.play.name + "にはわからなかった";
    let lover = "不明";
    let lover_text = "";

    if( props.play.lover_end==="1" ){
        lover = props.play.lover_name;
        text = props.play.name + "の心に大きな穴が開いた";
        if( props.play.lover_classroom!=="" ){
            lover_text = props.play.lover_classroom;
        }
    }
    if( props.play.lover_end==="2" ){
        lover = props.play.lover_nick;
        text = props.play.name + "と" + props.play.lover_name + "、ふたりは仲良し";
        if( props.play.lover_classroom!=="" ){
            lover_text = props.play.lover_classroom+ "　" + props.play.lover_club;
        }
    }
    if( props.play.lover_end==="0" ){
        if( props.play.lover_point>=10 ){
            lover = props.play.lover_nick;
        } else if( props.play.lover_point>=5 ){
            lover = props.play.lover_name;
        }
        if( props.play.lover_point>=5 ){
            text = props.play.name + "は追いつけなかった";
        }
    }
    
    //text = text + 
    const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Fapart%2F"+props.play.gid+"&text="+encodeURIComponent(text+" #レトロインク");  

    return (
		<div id="death" className={classes.mainRoot}>
            <div style={{textAlign:"center",paddingTop:"0.5em",marginBottom:"0.5em",lineHeight:"1em"}}>
                <Typography variant="subtitle1">- 通知表 -</Typography>
            </div>
            <Divider/>
            <Table size="small">
                <TableBody>
                    <TableRow>
                        <TableCell>名前</TableCell>
                        <TableCell>{props.play.name}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>部活</TableCell>
                        <TableCell>{props.play.club}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>クラス</TableCell>
                        <TableCell>{props.play.classroom}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>恋人</TableCell>
                        <TableCell>
                            {lover}<br/>
                            {lover_text !=="" &&
                            <span style={{fontSize:"90%",color:"gray"}}>{lover_text}</span>
                            }
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {props.play.lover_end==="2" &&
            <div className={classes.happyEnd}>
                {props.play.name}と{props.play.lover_name}<br/>
                ふたりは仲良し<br/>
                <FontAwesomeIcon icon={"heart"} style={{color:"pink"}}/>
            </div>
            }
            {props.play.lover_end!=="2" &&
            <div className={classes.badEnd}>
                {text}
            </div>
            }
            <div style={{textAlign:"center",marginTop:"2em"}}>
                <a href={tweet_url} target="_blank" className="tw" rel="noopener noreferrer" style={{textDecoration:"none"}}><Tooltip title="ツイートする">
                    <Button variant="outlined" color="primary"><FontAwesomeIcon icon={["fab","twitter"]} style={{marginRight:"0.5em"}}/>ツイートする</Button>
                </Tooltip></a>
            </div>
            <AppBar position="fixed" color="primary" style={{position:"fixed",bottom:"0",top:"auto",lineHeight:"1em"}}>
                <Toolbar style={{padding:"0"}}>
                    <Button variant="text" color="default" onClick={next} style={{color:"white",width:"100%"}}>
                        <FontAwesomeIcon icon={"arrow-down"} style={{marginRight:"0.5em"}}/>NEW GAME</Button>
                </Toolbar>
            </AppBar>
		</div>
	);
}

export default Tweet;
